export default __webpack_public_path__ + "static/media/vertical.013cce51.png";